@if (overlay) {
  <div class="overlay">
    <div class="center">
      <ng-template [ngTemplateOutlet]="progressSpinner"></ng-template>
    </div>
  </div>
} @else {
  <mat-progress-spinner
    [diameter]="diameter"
    [mode]="mode"
    [color]="color"
    [strokeWidth]="strokeWidth"
    [value]="value">
  </mat-progress-spinner>
  <div class="spinnerTitle" [style]="isLanguageSpanish ? '--left: 40px' : '--left: 70px'">{{'Please wait' | translate}} ...</div>
}
<ng-template #progressSpinner>
  <mat-progress-spinner
    [diameter]="diameter"
    [mode]="mode"
    [color]="color"
    [strokeWidth]="strokeWidth"
    [value]="value">
  </mat-progress-spinner>
  <div class="spinnerTitle" [style]="isLanguageSpanish ? '--left: 40px' : '--left: 70px'">{{'Please wait' | translate}} ...</div>
</ng-template>
